import { Apple, Plus, FileDown, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function NutritionSidebar({ plans, currentPlan, onLoadPlan, onReset, onExportPDF, onDelete }) {
  return (
    <div className="w-64 flex-shrink-0 border-r border-slate-200 p-4 flex flex-col gap-4 bg-white">
      <div className="flex items-center justify-between">
        <h1 className="text-lg font-bold text-slate-900 flex items-center gap-2" data-testid="nutrition-page-title">
          <Apple className="w-5 h-5 text-emerald-500" /> Ernährungsplan
        </h1>
        <Button size="sm" variant="outline" onClick={onReset} data-testid="new-nutrition-btn"><Plus className="w-4 h-4" /></Button>
      </div>
      <div className="overflow-y-auto space-y-2 flex-1">
        <h2 className="text-xs font-semibold text-slate-400 uppercase">Gespeicherte Pläne</h2>
        {plans.length === 0 && <p className="text-xs text-slate-400">Noch keine Pläne</p>}
        {plans.map(plan => (
          <div key={plan.id} onClick={() => onLoadPlan(plan)}
            className={`p-3 rounded-lg border cursor-pointer transition-all ${currentPlan?.id === plan.id ? 'border-emerald-400 ring-2 ring-emerald-100 bg-emerald-50' : 'border-slate-200 hover:border-slate-300'}`}
            data-testid={`nutrition-plan-${plan.id}`}>
            <div className="flex items-center justify-between">
              <p className="text-sm font-semibold text-slate-800 truncate">{plan.name}</p>
              <div className="flex gap-0.5">
                <button onClick={(e) => { e.stopPropagation(); onExportPDF(plan.id); }} className="p-1 rounded hover:bg-slate-100"><FileDown className="w-3 h-3 text-slate-400" /></button>
                <button onClick={(e) => { e.stopPropagation(); onDelete(plan.id); }} className="p-1 rounded hover:bg-red-50"><Trash2 className="w-3 h-3 text-red-400" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
